import React, {ReactNode} from 'react';
import './PageLayout.scss';
import {LoadingSpinner} from '../LoadingSpinner/LoadingSpinner';

interface IPageBodyProps {
    isLoading?: boolean;
    t: (key: string) => string;
    children: ReactNode;
}

export const PageBody: React.FC<IPageBodyProps> = ({isLoading, t, children}) => (
    <div className="page-body">
        {isLoading ? <LoadingSpinner t={t}/> : children}
    </div>
);
